import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function CookieConsent() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("jd_cookie")) setShow(true);
  }, []);
  useEffect(() => {
    document.body.style.paddingBottom = show ? "6rem" : "";
    return () => { document.body.style.paddingBottom = ""; };
  }, [show]);
  const choose = (v) => { localStorage.setItem("jd_cookie", v); setShow(false); window.dispatchEvent(new Event("jd-cookie-change")); };
  if (!show) return null;
  return (
    <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 sm:max-w-sm z-[60] surface p-4 shadow-2xl" data-testid="cookie-consent">
      <div className="flex items-center gap-3">
        <Cookie className="text-primary shrink-0" size={18} />
        <p className="text-xs text-muted-foreground flex-1 leading-snug">
          {t("cookie.text")} <Link to="/legal/privacy" className="text-primary underline">{t("legal.privacy")}</Link>
        </p>
      </div>
      <div className="flex gap-2 mt-3 justify-end">
        <button onClick={() => choose("necessary")} className="btn-ghost !py-1.5 !px-3 text-xs" data-testid="cookie-necessary">{t("cookie.necessary")}</button>
        <button onClick={() => choose("all")} className="btn-primary !py-1.5 !px-3 text-xs" data-testid="cookie-accept">{t("cookie.accept")}</button>
      </div>
    </div>
  );
}
